import axios from 'axios';
import {withAuth} from "../utils/authTokens";


const instance = axios.create({
  baseURL: `${process.env.REACT_APP_USERMANAGEMENT_GATEWAY}`,
  headers: {
    'Access-Control-Allow-Origin': '*',
    "Content-Type": "application/json"
  }
});

// Login, refresh and logout handle their own errors; a 401/403 there is not an expired session
withAuth(instance, {skip: (config) => config?.url?.startsWith('/api/auth/')});

export default instance;
